const MAX_EMAIL_LENGTH = 254;
const MAX_LOCAL_PART_LENGTH = 64;
const MAX_DOMAIN_LENGTH = 253;
const MAX_DOMAIN_LABEL_LENGTH = 63;

/** Printable ASCII only (rejects accents, ç, emojis, etc.) */
const ASCII_ONLY = /^[\x21-\x7E]+$/;

const LOCAL_PART =
  /^(?!\.)(?!.*\.\.)(?!.*\.$)[a-zA-Z0-9](?:[a-zA-Z0-9._%+-]*[a-zA-Z0-9])?$/;

const DOMAIN_LABEL =
  /^[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/;

const TLD = /^[a-zA-Z]{2,}$/;

export function isValidEmail(email: string): boolean {
  if (!email || email.length > MAX_EMAIL_LENGTH) {
    return false;
  }

  if (email !== email.trim()) {
    return false;
  }

  if (/\s/.test(email)) {
    return false;
  }

  if (!ASCII_ONLY.test(email)) {
    return false;
  }

  if (email.includes("..")) {
    return false;
  }

  const atIndex = email.indexOf("@");
  const lastAtIndex = email.lastIndexOf("@");

  if (atIndex <= 0 || atIndex !== lastAtIndex || atIndex === email.length - 1) {
    return false;
  }

  const localPart = email.slice(0, atIndex);
  const domain = email.slice(atIndex + 1);

  if (
    localPart.length === 0 ||
    localPart.length > MAX_LOCAL_PART_LENGTH ||
    domain.length === 0 ||
    domain.length > MAX_DOMAIN_LENGTH
  ) {
    return false;
  }

  if (!LOCAL_PART.test(localPart)) {
    return false;
  }

  const labels = domain.split(".");

  if (labels.length < 2) {
    return false;
  }

  for (let i = 0; i < labels.length; i++) {
    const label = labels[i];

    if (
      label.length === 0 ||
      label.length > MAX_DOMAIN_LABEL_LENGTH ||
      !DOMAIN_LABEL.test(label)
    ) {
      return false;
    }

    if (i === labels.length - 1 && !TLD.test(label)) {
      return false;
    }
  }

  return true;
}
